import { Loader } from "lucide-react";

interface ProcessingModalProps {
  isOpen: boolean;
  message?: string;
}

const ProcessingModal: React.FC<ProcessingModalProps> = ({
  isOpen,
  message,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-8 rounded-lg text-center min-w-[300px] flex items-center justify-center flex-col">
        <h2 className="text-xl font-semibold mb-4">Processing...</h2>
        <p className="mb-4">{message}</p>
        <Loader className="w-12 h-12 animate-spin" />
      </div>
    </div>
  );
};

export default ProcessingModal;
